import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  disableGoogleAnalytics,
  enableGoogleAnalytics,
  getAnalyticsConsent,
  subscribeToAnalyticsConsent,
  trackPageView,
} from "../../analytics/googleAnalytics";

const GoogleAnalytics = () => {
  const location = useLocation();
  const [consent, setConsent] = useState(getAnalyticsConsent);

  useEffect(() => subscribeToAnalyticsConsent(setConsent), []);

  useEffect(() => {
    if (consent === "granted") {
      enableGoogleAnalytics();
    } else {
      disableGoogleAnalytics();
    }
  }, [consent]);

  useEffect(() => {
    if (consent !== "granted" || location.pathname.startsWith("/admin")) {
      return;
    }

    trackPageView(location.pathname);
  }, [consent, location.pathname]);

  return null;
};

export default GoogleAnalytics;
